import { useMutation } from '@tanstack/react-query';

import { AttachmentsRepository } from 'domain/repositories/IAttachmentsRepository';
import { ID } from 'domain/types/ID';
import { AttachmentContentType, AttachmentFile } from 'domain/entities/Attachment';
import { useHookInjection } from 'application/hooks';

export type UploadFileParams = {
  file: File;
  refersTo?: ID;
};

export const useCaseUploadFile = () => {
  const { requestUploadUrl, uploadFile } =
    useHookInjection<AttachmentsRepository>(AttachmentsRepository);

  const { mutateAsync, isPending } = useMutation<AttachmentFile, Error, UploadFileParams>({
    mutationFn: async ({ file }) => {
      const { uri, url } = await requestUploadUrl({
        name: file.name,
        contentType: file.type as AttachmentContentType,
      });

      await uploadFile({ url, file });

      return {
        uri,
        name: file.name,
        contentType: file.type as AttachmentContentType,
      };
    },
  });

  return {
    uploadFile: mutateAsync,
    isPending,
  };
};
